export const VALIDATION_ERROR: number = 422;
export const NOT_FOUND_ERROR: number = 404;
export const AUTHORIZATION_ERROR: number = 401;